/* eslint-disable camelcase */
export default class Invoice {
    created_at = '';
    created_by = '';
    created_by_user = '';
    updated_by_user = '';
    invoice_items = [];
    id = 0;
    memo = '';
    partner = {};
    partner_store = {};
    partner_id = 0;
    updated_by = '';
    lookup_payment_term = {};
    due_date = '';
    paid_amount = 0;
    balance = 0;
    sales_rep = {};
    sales_rep_id = 0;
    partner_store_id = 0;
    is_blank = 0;
    order_no = '';
    visible_date = '';
    is_prepaid = false;
    term = {};
    appliedPrepaidAmount = 0;
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/Invoice.js